import { Component, Input, OnInit } from '@angular/core';
import { MaPlatePreparationService } from '../ma-plate-preparation/ma-plate-preparation.service';
import { SenderDTO } from '../masterdata/models/sender-dto';
import { MessagesService } from '../messages/messages.service';
import { Plate, SourcePlate } from '../models/plate';
import { Sample } from '../models/sample';
import { Step } from '../models/step';
import { Storage } from '../models/storage';
import { ErrorHandler } from '../utils/error-handler';
import { ProcessFlow } from '../masterdata/models/processFlow';
import { Merge96Mode, PlateStatus, ProcessStep } from '../models/process-step';
import rfdc from 'rfdc';
import { priorityMap } from '../utils/priority-row';
import {showLatestComment} from "../utils/latest-comment-util";
import { formatDate,DatePipe } from "@angular/common";
import { PlateListDTO } from '../dto/plateListDTO';

@Component({
  selector: 'app-ma-preparation-merge',
  templateUrl: './ma-preparation-merge.component.html',
  styleUrls: ['./ma-preparation-merge.component.css']
})
export class MaPreparationMergeComponent implements OnInit {

  errorHandler: ErrorHandler = new ErrorHandler;
  readonly showLatestComment = showLatestComment;

  loading: boolean;
  blocked: boolean;
  selectedLabId: string;
  puid: string;
  plateToSearch: string = "";
  mapOfSenders = new Map();
  customerList: any[] = [];
  selectedSender: SenderDTO;

  plates: Plate[] = []
  selectedPlate: Plate;
  selectedPlateStepsMap: Map<string, Step>;

  scannedBarcodeToShow: string = "";

  selectedTabIndex: number = 0;

  storageList: Array<any> =[];
  selectedStorage: Storage;

  columnHeaders = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  rowHeaders = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];

  plateSampleMap = new Map();
  statusFilterList = [PlateStatus.EXTRACTION_COMPLETED, PlateStatus.MERGED, PlateStatus.MERGE_COMPLETED];
  selectedProcessFlow: ProcessFlow;
  processFlowData: ProcessFlow[];
  scannedPlate1: string = "";
  scannedPlate2: string = "";
  scannedPlate3: string = "";
  mergePlate1: Plate = new Plate();
  mergePlate2: Plate = new Plate();
  mergePlate3: Plate = new Plate();
  mergePlateStepsMap1: Map<string, Step> = new Map();
  mergePlateStepsMap2: Map<string, Step> = new Map();
  mergePlateStepsMap3: Map<string, Step> = new Map();
  inputDirty1: boolean = false;
  inputDirty2: boolean = false;
  inputDirty3: boolean = false;
  mergePlateSource1: SourcePlate = new SourcePlate();
  mergePlateSource2: SourcePlate = new SourcePlate();
  mergePlateSource3: SourcePlate = new SourcePlate();
  sourcePlatePositionMap: Map<string, string> = new Map();
  mergeTypeList = [{label:"Direct Merge", value: "DirectMerge"}];
  selectedMergeType: string = "DirectMerge";
  mergeMode: Merge96Mode = null
  selectedWorkFlow: string = ""
  currentPriority = 10
  clone = rfdc();
  showMergePlatesPopup: boolean = false;
  scannedPlates = ["", "", ""]
  @Input() isMergeSelectedFromPreparationComponent: boolean;
  @Input() tabId: number;
  @Input() scannedPlateID: string = null;
  tableSelectedRow: Plate;

  showDueDate = false;

  constructor(
    private readonly _messagesService: MessagesService,
    private readonly platePreparationService: MaPlatePreparationService,
    private readonly datePipe:DatePipe
  ) { }

  ngOnInit() {
    this.puid = localStorage.getItem("PUID");
    this.selectedLabId = JSON.parse(localStorage.getItem('lab')).lab._id;
    this.processFlowData = JSON.parse(localStorage.getItem("processFlowData"));
    this.getAnnounedPlates();
    this.selectedPlate = new Plate();
    this.selectedPlate.samples = []
    this.selectedPlateStepsMap = new Map();

    this.mergePlate1.samples = [];
    this.mergePlate2.samples = [];
    this.mergePlate3.samples = [];
    if(this.scannedPlateID && this.tabId == 2) {
      this.searchForPlateAction(this.scannedPlateID);
      this.scannedPlateID = null;
    }
  }

  ngOnChanges() {
    this.ngOnInit();
  }

  isPUIDPresent() {
    if (this.puid != null && this.puid != undefined && this.puid != '') {
      return true;
    }
    return false;
  }

  checkMerge(){
    if(this.isMergeSelectedFromPreparationComponent){
      this.getAnnounedPlates();
      this.isMergeSelectedFromPreparationComponent = false;
    }
    return true
  }

   preparePlateSearchDTO(labId: string, type?: string, status?: string, processFlowName?: string, fromDate?: Date): PlateListDTO {
      const plateListDTO = new PlateListDTO();
      plateListDTO.labId = labId;
      if (typeof type !== 'undefined') {
        plateListDTO.type = type;
      }
      if (typeof status !== 'undefined') {
        plateListDTO.status = status;
      }
      if (typeof processFlowName !== 'undefined') {
        plateListDTO.processFlowName = processFlowName;
      }
      if (fromDate !== undefined && fromDate !== null) {
        plateListDTO.fromDate = formatDate(fromDate, 'yyyy-MM-dd', 'en-US')
      }
      return plateListDTO;
    }

  getAnnounedPlates() {
    this.loading = true;
    this.platePreparationService.fetchPlates(this.preparePlateSearchDTO(this.selectedLabId, "PLATE" ,this.statusFilterList.join(','))).subscribe({
      next : (result) => {
        this.loading = false;
        this.plates = result;
        if(this.selectedPlate.plateID != null){
          for(let i=0; i<this.plates.length; i++){
            if(this.selectedPlate.plateID == this.plates[i].plateID){
              this.tableSelectedRow = this.plates[i]
              break
            }
          }
        }
      },
      error: (error: any) => {
        this.loading = false;
        console.log("Error in fetching received plates ", error);
        this._messagesService.addErrorMessage({
          severity: 'error', summary: 'Failed to fetch plates',
          detail: 'Some issue in pulling the plates info, please try again'
        })
      }
    })
  }

  removePlateSelection(){
    this.selectedPlate = new Plate();
    this.selectedPlate.samples = []
    this.selectedPlateStepsMap = new Map();
    this.plateSampleMap.clear();
  }

  searchForPlateAction(plateID: string){
    this.blocked = true;
    this.platePreparationService.fetchPlate(plateID,this.selectedLabId).subscribe(
      (result) => {
        this.blocked = false;
        this.selectedPlate = result;
        this.prepareProcessStepsMap();
      }, (error) => {
        this.blocked = false;
        this._messagesService.addErrorMessage({
          severity: "error", summary: "Plate Not Found",
          detail: "Plate with plateID-"+plateID+" not found."
        })
      }
    )
  }

  prepareProcessStepsMap(mergePlateIndex: string = undefined) {
    if(!mergePlateIndex){
      this.selectedPlateStepsMap.clear();
      if(!this.selectedPlate.processSteps || this.selectedPlate.processSteps==null)
        return;
      this.selectedPlate.processSteps.forEach(step => {
        this.selectedPlateStepsMap.set(step.step, step);
      })
    }
    else{
      this["mergePlateStepsMap"+mergePlateIndex].clear();
      if(!this["mergePlate"+mergePlateIndex].processSteps || this["mergePlate"+mergePlateIndex].processSteps==null)
        return;
      this["mergePlate"+mergePlateIndex].processSteps.forEach(step => {
        this["mergePlateStepsMap"+mergePlateIndex].set(step.step, step);
      })
    }
  }

  findAndHighlightElement(elementId){
    let element = document.getElementById(elementId);
    if(element){
      element.focus();
    }
  }

  searchForPlate() {
    if(!this.plateToSearch || this.plateToSearch===''){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'Please enter a plateID',
        detail: 'Plate ID cannot be empty, please enter something to search'
      })
      return;
    }
    //this.searchForPlateAction(this.plateToSearch);
  }

  getSampleAt(row: number, col: number) {
    let positionString = this.getRowColStringFromPos(row, col);
    if (this.plateSampleMap.has(positionString)) {
      return this.plateSampleMap.get(positionString);
    }
    let sample = new Sample();
    sample.sampleID='';
    return sample;
  }

  getRowColStringFromPos(row: number, col: number) {
    return this.rowHeaders[row] + this.columnHeaders[col];
  }

  disableCompleteMergeButton(){
    if(this.selectedPlate.samples.length==0)
      return true
  }

  disableCompleteMergePopUpButton(){
    if(this.selectedPlate.plateID === undefined || this.selectedPlate.plateID === null )
      return true
  }

  addPlateToMerge(mergePlateIndex : string){
    this["inputDirty"+mergePlateIndex] = false;
    if(this["scannedPlate"+mergePlateIndex].trim()==""){
      if(mergePlateIndex!='3' && this["mergePlate"+(parseInt(mergePlateIndex)+1).toString()].samples.length != 0){
        this["inputDirty"+mergePlateIndex] = true;
        this._messagesService.addWarningMessage({
          severity:"warn", summary:"Plate not removed!",
          detail: "Please remove other plates before removing this plate."
        })
        this["scannedPlate"+mergePlateIndex] = this["mergePlate"+mergePlateIndex].plateID;
        return;
      }
      this.resetMergePlateValues(mergePlateIndex);
      this.mergeSamples(mergePlateIndex);
      return;
    }

    if(this.scannedPlates.includes(this["scannedPlate"+mergePlateIndex])){
      this._messagesService.addWarningMessage({
        severity: "warn", summary: "Plate not added",
        detail: "Plate already scanned. Please scan a new plate."
      });
      return;
    }
    else{
      this.scannedPlates[parseInt(mergePlateIndex)-1] = this["scannedPlate"+mergePlateIndex];
    }

    if(mergePlateIndex!='1' && this["mergePlate"+(parseInt(mergePlateIndex)-1).toString()].samples.length == 0){
      this._messagesService.addWarningMessage({
        severity: "warn", summary: "Plate not added",
        detail: "Plate with plateID "+this["scannedPlate"+mergePlateIndex]+" cannot be added as plateID-"+(parseInt(mergePlateIndex)-1).toString()+" is not yet scanned. Please scan it first."
      });
      this.resetMergePlateValues(mergePlateIndex);
      return;
    }

    let nextPosition = this.getPositionFromSampleCount(mergePlateIndex);
    if ( nextPosition == "A13"){
      this._messagesService.addErrorMessage({
        severity: "error", summary: "Plate not added",
        detail: "Plate is full with samples. More samples cannot be added."
      });
      this.resetMergePlateValues(mergePlateIndex);
      return;
    }

    this.blocked = true;
    this.platePreparationService.fetchPlate(this["scannedPlate"+mergePlateIndex].trim(),this.selectedLabId).subscribe(
      (result) => {
        this.blocked = false;
        this["mergePlate"+mergePlateIndex] = result;
        this["scannedPlate"+mergePlateIndex] = result.lastUpdatedPlateID;
        this.updateSourcePlatePositionMap(result);

        if(mergePlateIndex === "1"){
          this.mergeMode = result.scanHorizontal ? Merge96Mode.HORIZONTAL : Merge96Mode.VERTICAL
          this.selectedPlate.sampleType = result.sampleType
          this.selectedPlate.workFlow = result.workFlow
          this.selectedPlate.sender = result.sender
          this.selectedPlate.processFlowName = result.processFlowName
        }

        else if(mergePlateIndex !== "1"){
          if(this.mergeMode === Merge96Mode.HORIZONTAL && !result.scanHorizontal){
            this._messagesService.addErrorMessage({
              severity :'error',summary:'Mismatch',
              detail : `Plate ${result.plateID} is not allowed to merge as it was scanned vertically in reception.Please try again with a plate which was scanned horizontally`
            })
            this.resetMergePlateValues(mergePlateIndex)
            return
          }
          else if(this.mergeMode === Merge96Mode.VERTICAL && result.scanHorizontal){
            this._messagesService.addErrorMessage({
              severity :'error',summary:'Mismatch',
              detail : `Plate ${result.plateID} is not allowed to merge as it was scanned horizontally in reception.Please try again with a plate which was scanned vertically`
            })
            this.resetMergePlateValues(mergePlateIndex)
            return
          }
          if(!this.selectedPlate.sampleType.includes(result.sampleType)){
            this.selectedPlate.sampleType += `,${result.sampleType}`
          }
        }

        this.selectedPlate.priority = Math.min(this.currentPriority,result.priority)

        if(this["mergePlate"+mergePlateIndex].status != PlateStatus.EXTRACTION_COMPLETED){
          this._messagesService.addErrorMessage({
            severity: "error", summary: "Plate not added",
            detail: "Plate with plateID "+this["scannedPlate"+mergePlateIndex]+" cannot be added as it is not in "+PlateStatus.EXTRACTION_COMPLETED+" status."
          });
          this.resetMergePlateValues(mergePlateIndex);
          return;
        }

        if(!this["mergePlate"+mergePlateIndex].sampleType){
          this._messagesService.addErrorMessage({
            severity: "error", summary: "Plate not added",
            detail: "Plate with plateID "+this["scannedPlate"+mergePlateIndex]+" cannot be added as it has no sample type."
          });
          this.resetMergePlateValues(mergePlateIndex);
          return;
        }

        if(this["mergePlate"+mergePlateIndex].samples.length == 0){
          this._messagesService.addErrorMessage({
            severity: "error", summary: "Plate not added",
            detail: "Plate with plateID "+this["scannedPlate"+mergePlateIndex]+" cannot be added as it has 0 samples."
          });
          this.resetMergePlateValues(mergePlateIndex);
          return;
        }

        this.prepareProcessStepsMap(mergePlateIndex);

        if(!this.matchProcessFlowConditions(mergePlateIndex)){
          this._messagesService.addErrorMessage({
            severity: "error", summary: "Plate not added",
            detail: "Plate with plateID "+this["scannedPlate"+mergePlateIndex]+" cannot be added as it has different sample flow properties configured."
          });
          this.resetMergePlateValues(mergePlateIndex);
          return;
        }

        if(this.mergeSamples(mergePlateIndex)){
          this._messagesService.addSuccessMessage({
            severity: 'success', summary: "Plate added!"
          })
        }
        else{
          this.resetMergePlateValues(mergePlateIndex);
          return;
        }

        this.findAndHighlightElement("scannedPlateInput"+ (parseInt(mergePlateIndex)+1).toString())
      }, (error) => {
        this.blocked = false;
        this._messagesService.addErrorMessage({
          severity: "error", summary: "Plate Not Found",
          detail: "Plate with plateID "+this["scannedPlate"+mergePlateIndex]+" not found."
        })
        this.resetMergePlateValues(mergePlateIndex);
      }
    )
  }

  updateSourcePlatePositionMap(plate: Plate) {
    if(plate.samples && plate.samples.length > 0) {
      plate.samples.forEach(sample => {
        this.sourcePlatePositionMap.set(sample.sampleID, sample.position);
      });
    }
  }

  mergeSamples(mergePlateIndex: string){
    const sourcePlate = new SourcePlate();
    sourcePlate.plateID = this["mergePlate"+mergePlateIndex].plateID;
    sourcePlate.lastUpdatedPlateID = this["mergePlate"+mergePlateIndex].lastUpdatedPlateID;
    sourcePlate.processFlowName = this["mergePlate"+mergePlateIndex].processFlowName;
    sourcePlate.sampleType = this["mergePlate"+mergePlateIndex].sampleType;
    sourcePlate.status = this["mergePlate"+mergePlateIndex].status;
    sourcePlate.redoSampleType = "";
    sourcePlate.redoType = "";
    this["mergePlateSource"+mergePlateIndex] = sourcePlate;

    const mergePlate1SamplesCount = this.mergePlate1.samples.length;
    const mergePlate2SamplesCount = this.mergePlate2.samples.length;
    const mergePlate3SamplesCount = this.mergePlate3.samples.length;
    if((mergePlate1SamplesCount+mergePlate2SamplesCount+mergePlate3SamplesCount) > 96){
      this._messagesService.addErrorMessage({
        severity:"error", summary: "Plate not added",
        detail: 'Plate not added as total samples is more than 96.'
      })
      return false;
    }

    const currentPlateSamples = this["mergePlate"+mergePlateIndex].samples as Sample[];
    for(const sample of currentPlateSamples){
      if(this.selectedMergeType === "DirectMerge"){
        if(this.plateSampleMap.has(sample.position)){
          this._messagesService.addErrorMessage({
            severity: "error",
            summary: "Position Conflict",
            detail: `Position ${sample.position} already exists in the selected plate. Please resolve the conflict.`
          });
          return false;
        }
        sample.sourcePlatePosition = this.sourcePlatePositionMap.get(sample.sampleID);
        sample.sourcePlateID = this["mergePlate"+mergePlateIndex].plateID;
        sample.color = this.getSampleColor(Number.parseInt(mergePlateIndex));
        this.plateSampleMap.set(sample.position,sample);
        this.selectedPlate.samples.push(sample);
      }
    }
    return true;
  }

  getSampleColor(plateIndex: number) {
    switch (plateIndex) {
      case 1:
        return "#b5e61d";
      case 2:
        return "#ffaec9";
      case 3:
        return "#99d9ea";
      default:
        return "#db9e9e";
    }
  }

  prepareSamplesMap(){
    this.plateSampleMap.clear();
    this.selectedPlate.samples.forEach(sample => {
      this.plateSampleMap.set(sample.position,sample);
    })
  }

  incrementSelectedCell(selectedCell: string){
    let row = selectedCell[0],col = Number.parseInt(selectedCell.substring(1)), rowDiff = 0, colDiff = 0;
    if(this.mergeMode === Merge96Mode.VERTICAL){
      col = row ==  this.rowHeaders[7]? col+1 : col;
      rowDiff = row.charCodeAt(0) - 'A'.charCodeAt(0)
      row = this.rowHeaders[(rowDiff + 1) % 8];
    }
    else{
     let rowIndex = col === this.columnHeaders[11] ? this.rowHeaders.indexOf(row) + 1 : this.rowHeaders.indexOf(row)
     row = rowIndex == 8 ? this.rowHeaders[0] : this.rowHeaders[rowIndex]
     col = col == 12 ? 1 : col + 1
    }
    return row+col;
  }

  getPositionFromSampleCount(mergePlateIndex: string){
    if(this.mergeMode === Merge96Mode.HORIZONTAL){
      return this.getPositionBasedOnMergeMode(mergePlateIndex,12)
    }
    else if(this.mergeMode === Merge96Mode.VERTICAL){
      return this.getPositionBasedOnMergeMode(mergePlateIndex,8)
    }
    else{
      return "A1"
    }
  }

  getPositionBasedOnMergeMode(mergePlateIndex:string,rowColCalculationParam:number){
    let mergePlate1SamplesCount = this.mergePlate1.samples.length;
    let mergePlate2SamplesCount = this.mergePlate2.samples.length;
    let count = 0;
    if(this.selectedMergeType == "DirectMerge"){
      switch(mergePlateIndex){
        case '1':
          count=0;
          return "A1"
        case '2':
          count = mergePlate1SamplesCount
          if(mergePlate1SamplesCount % rowColCalculationParam != 0)
            count += (rowColCalculationParam-mergePlate1SamplesCount%rowColCalculationParam)
          break;
        case '3':
          count = mergePlate1SamplesCount + mergePlate2SamplesCount
          if(mergePlate1SamplesCount % rowColCalculationParam != 0)
            count += (rowColCalculationParam - mergePlate1SamplesCount % rowColCalculationParam)
          if(mergePlate2SamplesCount % 8 != 0)
            count += (rowColCalculationParam - mergePlate2SamplesCount % rowColCalculationParam)
          break;
        default:
            break;
      }
    }
    else{
      switch(mergePlateIndex){
        case '1':
          count = 0;
          return "A1"
        case '2':
          count = mergePlate1SamplesCount;
          break;
        case '3':
          count = mergePlate1SamplesCount + mergePlate2SamplesCount;
          break;
        default:
          break;
      }
    }
    if(count == 0){
      return "A1"
    }

    var row = 0 , column = 0
    if(this.mergeMode === Merge96Mode.HORIZONTAL){
      row = Math.floor(count / rowColCalculationParam);
      column = count % rowColCalculationParam + 1;
    }
    else{
      row = count%rowColCalculationParam;
      column = Math.ceil(count / rowColCalculationParam)
        if(row==0){
          column++;
        }
    }
    return this.rowHeaders[row]+column
  }


  resetMergePlateValues(mergePlateIndex: string){
    this["mergePlate"+mergePlateIndex] = new Plate();
    this["mergePlate"+mergePlateIndex].samples = [];
    this["scannedPlate"+mergePlateIndex] = "";
    this["mergePlateSource"+mergePlateIndex] = new SourcePlate();
    this["sampleMapPlate"+mergePlateIndex] = new Map();
    this.scannedPlates[parseInt(mergePlateIndex)-1] = "";
    if(mergePlateIndex === "1"){
      this.mergeMode = null
      this.selectedPlate = new Plate();
      this.selectedPlate.samples = [];
      this.prepareSamplesMap();
      return;
    }
    else{
      const currentSampleType = this.selectedPlate.sampleType.split(",");
      currentSampleType.splice(parseInt(mergePlateIndex)-1,1)
      this.selectedPlate.sampleType = currentSampleType.join(",")
    }
    if(mergePlateIndex === '2'){
        this.selectedPlate.samples.splice(this.mergePlate2.samples.length);
    } else {
        this.selectedPlate.samples.splice(this.mergePlate2.samples.length + this.mergePlate3.samples.length);
    }
    this.prepareSamplesMap();
  }

  openCompleteMergePopUp(){
    let emptyScannedPlatesListCount = 0;
    let emptyScannedPlatesCount = 0;
    this.scannedPlates.forEach((plateID, index) => {
      if(plateID == "")
        emptyScannedPlatesListCount+=1;
      if(this["scannedPlate"+(index+1).toString()].trim() == "")
        emptyScannedPlatesCount += 1;
    })

    if((emptyScannedPlatesCount != emptyScannedPlatesListCount) || (this.inputDirty1 || this.inputDirty2 || this.inputDirty3)){
      this._messagesService.addWarningMessage({
        severity:'warn', summary: "Cannot merge plate!",
        detail:"Please scan the plates properly!"
      })
      return;
    }

    if((emptyScannedPlatesCount == 2) || (emptyScannedPlatesListCount==2)){
      this._messagesService.addWarningMessage({
        severity:'warn', summary: "Cannot merge plate!",
        detail:"Cannot merge single plate. Scan more plates!"
      })
      return;
    }
    this.showMergePlatesPopup = true;
    setTimeout( () => {
      this.findAndHighlightElement("popup-plateid");
    },200);
  }

  setAliquoationProcessStepForMergedPlate(): Step[]{
    let aliquotationStartedStep :Step = {
      step : ProcessStep.ALIQUOTATION,
      startPUID : this.puid,
      startTimeStamp: new Date(),
      endTimeStamp: new Date(),
      endPUID : this.puid,
      action: [],
      liquidHandler : "",
      endLiquidHandler: "",
      chemicals: []
    }
    return [aliquotationStartedStep]
  }

  completeMerge() {
    this.selectedPlate.status = PlateStatus.ALIQUOTATION_COMPLETED;
    this.selectedPlate.processSteps = this.setAliquoationProcessStepForMergedPlate();
    if ([this.scannedPlate1, this.scannedPlate2, this.scannedPlate3].includes(this.selectedPlate.plateID.trim())) {
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'Please scan a new plate-id!',
        detail: "New plate id is same as the scanned plate."
      })
    } else {
      this.selectedPlate.mergePlateIDs = [this.scannedPlate1, this.scannedPlate2, this.scannedPlate3]
      this.selectedPlate.labID = this.selectedLabId
      this.selectedPlate.hasRedoSamples = false;
      this.updateSourcePlates();
      this.createNewMergePlate();
    }
  }

  updateSourcePlates() {
    this.selectedPlate.sourcePlates = [];
    if(this.mergePlateSource1?.plateID) {
      this.selectedPlate.sourcePlates.push(this.mergePlateSource1);
    }

    if(this.mergePlateSource2?.plateID) {
      this.selectedPlate.sourcePlates.push(this.mergePlateSource2);
    }

    if(this.mergePlateSource3?.plateID) {
      this.selectedPlate.sourcePlates.push(this.mergePlateSource3);
    }
  }

  resetAfterMergeCompleted(){
    this.getAnnounedPlates();
    this.removePlateSelection();
    this.resetFieldsForMerge();
  }

  updatePlate() {
    if(!this.isPUIDPresent()){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'USER ID not present!',
        detail: 'Please  enter USER ID before moving ahead',
      });
      return;
    }
    this.blocked = true;
    this.platePreparationService.updatePlate(this.selectedPlate.plateID,this.selectedPlate,this.selectedLabId).subscribe({
      next : (_result) => {
        this.blocked = false;
        this.showMergePlatesPopup = false;
        this._messagesService.addSuccessMessage({
          severity: 'success', summary: 'Plate '+this.selectedPlate.plateID+' is updated',
          detail: this.selectedPlate.plateID+' has been updated successfully with requested status'
        });
        this.resetAfterMergeCompleted();
        this.getAnnounedPlates();
      }, error: (error: any) => {
        this.blocked = false;
        this._messagesService.addErrorMessage({
          severity: 'error', summary: 'Plate '+this.selectedPlate.plateID+' is not updated',
          detail: this.selectedPlate.plateID+' has not updated with the merged samples.'
        })
      }
    })
  }

  createNewMergePlate(){
    if(!this.isPUIDPresent()){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'USER ID not present!',
        detail: 'Please  enter USER ID before moving ahead',
      });
      return;
    }
    this.blocked = true;
    this.selectedPlate.lastUpdatedPlateID = this.selectedPlate.plateID
    this.platePreparationService.createPlate(this.selectedPlate).subscribe({
      next : (_result) => {
        this.blocked = false;
        this.showMergePlatesPopup = false;
        this._messagesService.addSuccessMessage({
          severity: 'success', summary: 'Plate '+this.selectedPlate.plateID+' is updated',
          detail: this.selectedPlate.plateID+' has been updated successfully with requested status'
        });
        this.resetAfterMergeCompleted();
      }, error: (error: any) => {
        this.blocked = false;
        this._messagesService.addErrorMessage({
          severity: 'error', summary: 'Plate '+this.selectedPlate.plateID+' is not updated',
          detail: this.selectedPlate.plateID+' has not updated with the merged samples.'
        })
      }
    })
  }

  changeMergeType(){
    if(!this.mergeSamples("1")){
      if(this.selectedMergeType == "DirectMerge")
        setTimeout(() => {
          this.selectedMergeType = "AdjustedMerge";
          this.mergeSamples("1");
        }, 50);
      else
        setTimeout(() => {
          this.selectedMergeType = "DirectMerge"
          this.mergeSamples("1");
        }, 50)
    }
  }

  matchProcessFlowConditions(mergePlateIndex){
    if(!this.selectedProcessFlow){
      for(let i=0; i<this.processFlowData.length; i++){
        if(this["mergePlate"+mergePlateIndex].processFlowName.trim() == this.processFlowData[i].processFlowName.trim()){
          this.selectedProcessFlow = this.processFlowData[i];
          break;
        }
      }
      return true
    }

    let processFlowToBeCompared:ProcessFlow;
    for(let i=0; i<this.processFlowData.length; i++){
      if(this["mergePlate"+mergePlateIndex].processFlowName.trim() == this.processFlowData[i].processFlowName.trim()){
        processFlowToBeCompared = this.processFlowData[i];
        break;
      }
    }
    if(!processFlowToBeCompared || (
        this.selectedProcessFlow.illuminaExInfinium != processFlowToBeCompared.illuminaExInfinium ||
        this.selectedProcessFlow.axiom384Propel != processFlowToBeCompared.axiom384Propel ||
        this.selectedProcessFlow.manualPreparation != processFlowToBeCompared.manualPreparation ||
        this.selectedProcessFlow.precell != processFlowToBeCompared.precell ||
        this.selectedProcessFlow.manualPost != processFlowToBeCompared.manualPost
      )){
      return false;
    }
    return true
  }

  getPriorityClass(priority:number){
    return priorityMap[priority];
  }

  resetFieldsForMerge(){
    this.removePlateSelection();
    this.plateToSearch = "";
    this.scannedPlate1 = "";
    this.scannedPlate2 = "";
    this.scannedPlate3 = "";
    this.mergePlate1.samples = [];
    this.mergePlate2.samples = [];
    this.mergePlate3.samples = [];
    this.mergePlateStepsMap1 = new Map();
    this.mergePlateStepsMap2 = new Map();
    this.mergePlateStepsMap3 = new Map();
    this.inputDirty1 = false;
    this.inputDirty2 = false;
    this.inputDirty3 = false;
    this.scannedPlates = ["", "", ""]
  }

  convertUtcToLocal(date: Date){
    if(!date || date==null) {
      return null
    };

    const offset = new Date().getTimezoneOffset();
    const dateInLocal = new Date(date);
    dateInLocal.setMinutes(dateInLocal.getMinutes()-offset);
    return dateInLocal;
  }

  checkStatusChange(plate: Plate): boolean{
    return plate?.lastModifiedDate === plate?.adminChangeTimeStamp;
  }
}
